"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uid = _interopRequireDefault(require("../../../../utils/uid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ImplicitFileInput = function ImplicitFileInput(_ref) {
  var onChange = _ref.onChange,
      beforeUpload = _ref.beforeUpload,
      accept = _ref.accept,
      files = _ref.files,
      multiple = _ref.multiple,
      props = _objectWithoutProperties(_ref, ["onChange", "beforeUpload", "accept", "files", "multiple"]);

  var handleChange = function handleChange(_ref2) {
    var file = _ref2.file,
        fileList = _ref2.fileList;
    onChange({
      file: file,
      fileList: [].concat(_toConsumableArray(files), _toConsumableArray(fileList))
    });
  };

  var upload = function upload(file, fileList) {
    if (!beforeUpload) {
      // always async in case use react state to keep fileList
      setTimeout(function () {
        return onChange({
          file: file,
          fileList: fileList
        });
      }, 0);
      return;
    }

    var before = beforeUpload(file, fileList);

    if (before && before.then) {
      before.then(function (processedFile) {
        var processedFileType = Object.prototype.toString.call(processedFile);

        if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
          onChange({
            file: file,
            fileList: fileList
          });
          return;
        }

        handleChange({
          file: file,
          fileList: fileList
        });
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      });
    } else if (before !== false) {
      setTimeout(function () {
        return handleChange({
          file: file,
          fileList: fileList
        });
      }, 0);
    } else {
      handleChange({
        file: file,
        fileList: fileList
      });
    }
  };

  var uploadFiles = function uploadFiles(e) {
    var files = e.target.files;
    var fileList = Array.prototype.slice.call(files);
    fileList.map(function (file) {
      // eslint-disable-next-line no-param-reassign
      file.uid = (0, _uid.default)();
      return file;
    }).forEach(function (file) {
      upload(file, fileList);
    });
  };

  return /*#__PURE__*/_react.default.createElement("input", _extends({}, props, {
    onChange: uploadFiles,
    multiple: multiple,
    type: "file",
    accept: accept
  }));
};

ImplicitFileInput.propTypes = {
  onChange: _propTypes.default.func,
  beforeUpload: _propTypes.default.func,
  accept: _propTypes.default.string,
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    uid: _propTypes.default.string,
    name: _propTypes.default.string
  })),
  multiple: _propTypes.default.bool
};
ImplicitFileInput.defaultProps = {
  onChange: function onChange() {},
  beforeUpload: function beforeUpload() {},
  accept: '*',
  files: [],
  multiple: false
};
var _default = ImplicitFileInput;
exports.default = _default;